<script setup>
import { ref, onMounted, getCurrentInstance, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { usePageLoadingStore } from "../../../../stores/pageLoading";
import adminUserService from "../../services/user/adminUserService";
import jobFairUserService from "../../../user/services/jobFair/jobFairUserService";
import adminJobfairService from "../../services/jobfair/adminJobfairService";
import adminJoinStateService from "../../services/jobfair/adminJoinStateService";
import adminApprovedJoinStateService from "../../services/jobfair/adminApprovedJoinStateService";
import SNBAdmin from "../../../../layouts/nav/SNBAdmin.vue";
import KSASecondaryButton from "../../../../components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "../../../../components/ui-components/button/KSAPrimaryButton.vue";
import JobFairResumeModal from "../../../user/components/modal/jobFair/JobFairResumeModal.vue";
import JobFairJobNoticeModal from "../../../user/components/modal/jobFair/JobFairJobNoticeModal.vue";
import JobFairResumeOpenModal from "../../../user/components/modal/jobFair/JobFairResumeOpenModal.vue";
import _ from "lodash";

const route = useRoute();
const router = useRouter();
const loadingStore = usePageLoadingStore();
const { $pageListBoardNo, $toast, $number, $gbNameKR, $yyyymmddHHmmss, $downloadForPrivate } = getCurrentInstance().appContext.config.globalProperties;
const loaded = ref(false); // 데이터 받고 난 후, 화면 그리는 용도

const ojfId = ref(route.query.ojfId || '');
const userId = ref(route.query.userId || '');

const intvDays = ref([]);     // 면접 가능일
const isAllActive = ref(false); // 면접일 전체
const isEtcActive = ref(false); // 면접일 외 일정
const entryInputError = ref({
    joinPurpose: '',
    intvAbleDay: '',
})

const ojfDetail = ref({});                  // 행사 정보(for 행사명)
const entryDetail = ref(null);              // 참가신청 정보 관리 TAB(1)
const resumeList = ref([]);                 // 이력서 관리 및 입사지원 현황 TAB(2)
const applicantList = ref([]);              // 이력서 관리 및 입사지원 현황 TAB(2) - 입사지원 리스트
const interestHallList = ref([]);           // 관심 기업 TAB(3)
const jobNoticeList = ref([]);              // 관심 기업 TAB(3) - 채용공고 리스트
const interestJobNoticeList = ref([]);      // 관심 공고 TAB(4)
const interviewProposalEntryList = ref([]); // 받은 면접제안 TAB(4)

onMounted( async () => {
    await ojfIntvDay();       // 행사 면접 가능일 조회
    retrieveOnlineJobFair();  // 행사 정보 조회(for 행사명)
    retrieveEntry();          // 참가신청 정보 조회
})

// tabIndex
const tabOptions = ref([
    {label: '참가신청 정보 관리', value: 1},
    {label: '이력서 관리 및 입사지원 현황', value: 2},
    {label: '관심 기업', value: 3},
    {label: '관심 공고', value: 4},
    {label: '받은 면접제안', value: 5},
])
const BASIC = 'BASIC';                       // depth2 있는 tab의 기본 화면
const ENTRY_UPDATE = 'ENTRY_UPDATE';         // 참가신청 정보 관리 TAB(1) 수정 화면
const RESUME_APPLICANT = 'RESUME_APPLICANT'; // 이력서 관리 및 입사지원 현황 TAB(2) 입사지원 화면
const CORPORATION_JOBNOTICE = 'CORPORATION_JOBNOTICE'; //  관심 기업 TAB(3) 채용공고 화면

const detailCommonId = ref('');     // resumeId, corpId
const detailCommonData = ref('');   // fileYn

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);
const searchOpen = ref(true);

const tabIndex = ref(1);
const viewMode = ref(BASIC);  // depth2 있는 tab의 기본 화면

const modal = ref(null);
const confirmModal = ref(null);
const modalContent = ref([]);
const okButtonText = ref("다운로드");

const jobFairResumeModal = ref(null); // 이력서
const jobNoticeModal = ref(null); // 채용공고
const jobFairResumeOpenModal = ref(null); // 인재정보 공개

// 검색조건 - 페이지 크기
const pageSizeGroup = ref([
    { label:'10개씩 보기', value: '10' },
    { label:'30개씩 보기', value: '30' },
    { label:'50개씩 보기', value: '50' },
    { label:'100개씩 보기', value: '100' },
])

// 면접 가능일 조회. for 참가신청 정보 수정
const ojfIntvDay = async () => {
    loadingStore.loading = true;
    try {
        const res = await jobFairUserService.ojfIntvDay(ojfId.value);
        loadingStore.loading = false;

        if (res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            if (result) {
              const selectedDays = result.split(',').map(d => d.trim());

              intvDays.value = selectedDays.map(day => ({
                  label: day,
                  on: false
              }));
            }
        }
    } catch (error) {
        console.error(error);
        loadingStore.loading = false;
    }
}

// 면접 가능일 클릭
const onClickIntvDay = (clickedDay) => {
    entryInputError.value.intvAbleDay = '';
    isEtcActive.value = false
    entryDetail.value.intvInYn = 'Y';

    if (isAllActive.value) {
        // 전체 active 상태였다면 → 전체 해제하고 현재 날짜만 on
        isAllActive.value = false
        // isEtcActive.value = false
        entryDetail.value.intvInYn = 'Y';

        intvDays.value.forEach(day => {
            day.on = (day === clickedDay)
        })
    } else {
        // 전체 상태가 아닐 때는 토글만
        clickedDay.on = !clickedDay.on
        // 날짜 전체가 선택되었는지 확인
        const allSelected = intvDays.value.every(day => day.on)
        isAllActive.value = allSelected
    }
}

// 면접 가능일 전체
const onClickAll = (force) => {
  entryInputError.value.intvAbleDay = ''

    if (isAllActive.value && !force) {
        isAllActive.value = false
        isEtcActive.value = false

        intvDays.value.forEach(day => {
            day.on = false
        })
    } else {
        isAllActive.value = true
        isEtcActive.value = false

        intvDays.value.forEach(day => {
            day.on = true
        })
    }
}

// 면접 가능일 외
const onClickEtc = (force) => {
  entryInputError.value.intvAbleDay = ''

  if (isEtcActive.value && !force) {
    isEtcActive.value = false
    entryDetail.value.intvInYn = 'Y'
  } else {
    isEtcActive.value = true
    isAllActive.value = false
    entryDetail.value.intvInYn = 'N'

    intvDays.value.forEach(day => {
      day.on = false
    })
  }
}

// 행사 정보 조회 for 상단 행사명 타이틀
const retrieveOnlineJobFair = () => {
    loadingStore.loading = true;
    adminJobfairService.retrieveOnlineJobFair(ojfId.value)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                ojfDetail.value = res.data.result;
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// START: 참가신청 정보 관리 TAB
// 1. 참가신청 정보 조회
const retrieveEntry = () => {
    loadingStore.loading = true;
    adminJoinStateService.retrieveEntryByOjfIdAndUserId(ojfId.value, userId.value)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                entryDetail.value = res.data.result;
            }
            loaded.value = true; // 데이터 받고 나서 화면 그리기
        }).catch((res) => {
            loadingStore.loading = false;
            $toast("error", res);
    });
};

// 2. '신청 취소' 버튼
const cancelEntry = async (joinStateGb) => {
  modalContent.value = ["'신청 취소'로 상태가 변경됩니다."];
  okButtonText.value = "신청 취소";
  const ok = await confirmModal.value.show();
  if(!ok) {
     return -1;
  }

  let paramObj = {
    ojfId: ojfId.value,
    userId: userId.value,
    entrySeq: entryDetail.value.entrySeq,
    joinStateGb: joinStateGb,
  }
  adminUserService.updateEntryJoinStateByUserId(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          modalContent.value = ["참가 신청이 취소 되었습니다."];
          await modal.value.show();
          router.push({name: 'MemberDetail', params:{id: userId.value}});
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}
// 탭 상세 화면 보기 조건
const setViewMode = (viewName, commonId, commonData) => {
  // 공통 사용변수 초기화
  currentPage.value = 1;
  pageSize.value = 10;

  // depth2에서 사용할 데이터 들
  detailCommonId.value = commonId; // resumeId, corpId
  detailCommonData.value = commonData; // fileYn,

  if(viewName === BASIC) {
    retrieveList();
  } else if(viewName === ENTRY_UPDATE) { // 참가신청 정보 관리 TAB 수정 화면
    // 선택한 면접 날짜 가져오기
    const selectedDays = entryDetail.value.intvAbleDay?.split(',').map(day => day.trim()) || []

    setTimeout(() => {
      // 면접 가능 전체 날짜
      const allLabels = intvDays.value.map(day => day.label)

      if (entryDetail.value.intvInYn === 'Y') { // 면접 가능일내 날짜
        // "전체" 선택 여부 판단
        const isAll = selectedDays.length === allLabels.length &&
            selectedDays.every(day => allLabels.includes(day))

        if (isAll) {
          onClickAll(true)
        } else {
          isAllActive.value = false
          isEtcActive.value = false
          entryDetail.value.intvInYn = 'Y'

          intvDays.value.forEach(day => {
            day.on = selectedDays.includes(day.label)
          })
        }
      } else {
        // 그 외
        onClickEtc(true)
      }
    }, 100)
  } else if (viewName === RESUME_APPLICANT) { // 이력서 관리 및 입사지원 현황 TAB 입사지원 리스트
      retrieveApplicantList(commonId); // commonId : resumeId
  } else if (viewName === CORPORATION_JOBNOTICE) { // 관심 기업 TAB 채용공고 리스트
      retrieveJobNoticeListAdminPaging(commonId); // commonId : corpId
  }
  viewMode.value = viewName;
}
// 참가 신청 수정
const ojfUpdateEntry = () => {
  let isInvalid = false;

  // 참가 목적
  const { joinPurpose } = entryDetail.value;
  entryInputError.value.joinPurpose = '';

  // ella : 참가 목적 숨김 요청 (20250904)
  // if(!joinPurpose) {
  //   entryInputError.value.joinPurpose = '참가 목적을 입력하세요.';
  //   isInvalid = true;
  // }

  // 면접 가능일
  const intvAbleDay = _.map(_.filter(intvDays.value, {'on': true}), 'label').join(',');

  const { intvInYn } = entryDetail.value;
  entryInputError.value.intvAbleDay = '';

  if(!intvInYn) {
    entryInputError.value.intvAbleDay = '면접 가능일을 선택하세요.';
    isInvalid = true;
  } else if (intvInYn === 'Y' && !intvAbleDay) {
    entryInputError.value.intvAbleDay = '면접 가능일을 선택하세요.';
    isInvalid = true;
  }

  if (!isInvalid) {
    let paramObj = {
      ojfId: ojfId.value,
      joinPurpose: joinPurpose,
      intvInYn: intvInYn,
      intvAbleDay: intvAbleDay,
      userId: userId.value,
    }
    console.log(paramObj);
    loadingStore.loading = true;
    adminUserService.updateAdminEntry(paramObj)
        .then( async (res) => {
          if(res.data.code.toLowerCase() === 'success') {
            // const result = res.data.result;
            // console.log(result);
            // entryUpdate.value = result;
            setViewMode(BASIC);
            retrieveEntry();
            modalContent.value = ["수정 완료되었습니다."];
            await modal.value.show();
            loadingStore.loading = false;
          }
        }).catch( (error) =>  {
          // console.log(error);
          loadingStore.loading = false;
        });
  }
}

// 참가 신청 수정 취소
const cancelUpdateEntry = async () => {
  setViewMode(BASIC)
  retrieveEntry();
}
// END: 참가신청 정보 관리 TAB

// START: 이력서 관리 및 입사지원 현황 TAB
// 1. 이력서 리스트 조회
const retrieveOjfResumeListAdminPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        userId: userId.value,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminUserService.retrieveOjfResumeListAdminPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                resumeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// 입사지원 리스트 조회
const retrieveApplicantList = (resumeId) => {
  let paramObj = {
    ojfId: ojfId.value,
    resumeId: resumeId,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  loadingStore.loading = true;
  jobFairUserService.retrieveApplicantList(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === "success") {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          applicantList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch((res) => {
    loadingStore.loading = false;
    $toast("error", res);
  });
};

// 인재정보 공개 여부
const onClickChangeResOpenYn = async (userId, resumeId, resOpenYn) => {
  let ok = false;

  // 기존에 오픈된 이력서 존재 여부 확인. true/false
  const resumeY = resumeList.value.some(item => item.resOpenYn === 'Y');

  // resOpenYn Y인지 아닌지 check
  if ( resOpenYn === 'Y') { // 공개
    if ( resumeList.value.length > 1 ) { // 오픈된 기존 이력서가 존재할 경우
      if ( resumeY ) {
        ok = await jobFairResumeOpenModal.value.show(false);
      } else { // 오픈된 기존 이력서가 존재하지 않을 경우
        modalContent.value = ["해당 이력서를 공개 하시겠습니까?"];
        okButtonText.value = "확인";
        ok = await confirmModal.value.show();
      }
    }
  } else { // 비공개
    modalContent.value = ["해당 이력서를 비공개 하시겠습니까?"]; //
    okButtonText.value = "확인";
    ok = await confirmModal.value.show();
  }

  if ( ok ) {
    let paramObj = {
      userId: userId,
      resumeId: resumeId,
      ojfId: ojfId.value,
      resOpenYn: resOpenYn,
    }
    adminApprovedJoinStateService.updateStatusOjfResumeResOpenYnByAdmin(paramObj)
        .then( async (res) => {
          if (res.data.code.toLowerCase() === 'success') {
            //let result = res.data.result;
            //console.log(result);
            if(resOpenYn === 'Y') {
              modalContent.value = ["선택한 이력서가", "특별채용관 인재정보에 공개되었습니다."];
            } else if(resOpenYn === 'N') {
              modalContent.value = ["선택한 이력서가", "특별채용관 인재정보에 비공개되었습니다."];
            }
            await modal.value.show();
            loadingStore.loading = false;
            retrieveOjfResumeListAdminPaging();
          }
        }).catch((error) => {
      loadingStore.loading = false;
      console.log(error);
    });
  }
}
// END: 이력서 관리 및 입사지원 현황 TAB

// START: 관심 기업 TAB
// 1. 관심 기업 리스트 조회
const retrieveInterestHallEntryListAdminPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        userId: userId.value,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminUserService.retrieveInterestHallEntryListAdminPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                interestHallList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// 관심 기업의 채용공고 리스트
const retrieveJobNoticeListAdminPaging = (corpId) => {
  let paramObj = {
    ojfId: ojfId.value,
    corpId: corpId,
    userId: userId.value,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  loadingStore.loading = true;
  adminUserService.retrieveJobNoticeListAdminPaging(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === "success") {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          jobNoticeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch((res) => {
    loadingStore.loading = false;
    $toast("error", res);
  });
};

// END: 관심 기업 TAB

// START: 관심 공고 TAB
// 1. 관심 공고 리스트 조회
const retrieveInterestJobNoticeListAdminPaging = () => {
    let paramObj = {
        ojfId: ojfId.value,
        userId: userId.value,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminUserService.retrieveInterestJobNoticeListAdminPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                interestJobNoticeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};
// END: 관심 공고 TAB

// START: 받은 면접제안 TAB
// 1. 받은 면접제안 리스트 조회
const retrieveInterviewProposalEntryListAdminPaging = () => {
  let paramObj = {
    ojfId: ojfId.value,
    userId: userId.value,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  loadingStore.loading = true;
  adminUserService.retrieveInterviewProposalEntryListAdminPaging(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === "success") {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          interviewProposalEntryList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch((res) => {
    loadingStore.loading = false;
    $toast("error", res);
  });
};

// 면접제안 상태 변경
const onClickIntvPropState = async (resumeId, jobNoticeSeq, stateGb) => {
  if (stateGb === '02') {
    modalContent.value = ["면접 제안을 수락하시겠습니까?", "'제안수락'으로 상태가 변경됩니다."];
    okButtonText.value = "제안 수락";
  } else {
    modalContent.value = ["면접 제안을 거절하시겠습니까?", "'제안거절'로 상태가 변경됩니다."];
    okButtonText.value = "제안 거절";
  }
  const ok = await confirmModal.value.show();
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      resumeId: resumeId,
      jobNoticeSeq: jobNoticeSeq,
      intvPropStateGb: stateGb,
    }
    jobFairUserService.ojfUpdateIntvPropsState(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            modalContent.value = ["변경 하였습니다."];
            modal.value.show();
            //$toast('', "삭제를 하였습니다.")
            retrieveInterviewProposalEntryListAdminPaging();
          } else {
            modalContent.value = ["변경을 실패하였습니다."];
            modal.value.show();
            console.log(res);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      modalContent.value = ["변경을 실패하였습니다."];
      modal.value.show();
      console.log(res);
    });
  }
}
// END: 받은 면접제안 TAB

// 공동 함수 START
// 이력서 보기
const onClickMyResume = (resumeId) => {
  jobFairResumeModal.value.init(false);
  jobFairResumeModal.value.retrieveJobFairRecordDetail(resumeId, ojfId.value);
  jobFairResumeModal.value.show();
}

// 채용공고 보기
const onClickJobNotice = async (jobNoticeSeq, corpId) => {
  jobNoticeModal.value.init(false, false, false, ojfId.value);
  jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
  jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId.value, corpId);
  jobNoticeModal.value.ojfCorporationDetail(corpId);
  await jobNoticeModal.value.show();
}

// 입사지원 상태변경 joinStateGb
const onClickApplyStateGb = async (resumeId, jobNoticeSeq, stateGb) => {

  if (stateGb === "02") {
    modalContent.value = ["지원취소 처리하시겠습니까??", "'지원취소'으로 상태가 변경됩니다."];
    okButtonText.value = "지원취소";
  } else if (stateGb === "03") {
    modalContent.value = ["서류합격 처리하시겠습니까??", "'서류합격'으로 상태가 변경됩니다."];
    okButtonText.value = "서류합격";
  } else if (stateGb === "04") {
    modalContent.value = ["서류불합격 처리하시겠습니까??", "'서류불합격'으로 상태가 변경됩니다."];
    okButtonText.value = "서류불합격";
  }

  const ok = await confirmModal.value.show();
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      resumeId: resumeId,
      ojfId: ojfId.value,
      jobNoticeSeq: jobNoticeSeq,
      applyStateGb: stateGb,
    }
    jobFairUserService.ojfUpdateApplyStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            modalContent.value = ["변경 하였습니다."];
            modal.value.show();
            //$toast('', "삭제를 하였습니다.")
            if(tabIndex.value === 2) { // 이력서 관리 및 입사지원 현황
              retrieveApplicantList(resumeId);
            }
          } else {
            modalContent.value = ["변경을 실패하였습니다."];
            modal.value.show();
            console.log(res);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      modalContent.value = ["변경을 실패하였습니다."];
      modal.value.show();
      console.log(res);
    });
  }
}
// 공통 함수 END

// tabIndex 변경
const onChangeTab = async ({ value }) => {
    tabIndex.value = value;

    currentPage.value = 1;
    pageSize.value = 10;
    searchOpen.value = true;

    await ojfIntvDay();
    retrieveList();
}

// 페이지 선택
const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
};

// 페이지 사이즈 변경. 10,30,50,100
const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
}

// tab별 리스트 불러 오기 공통 함수
const retrieveList = () => {
    if(tabIndex.value === 1) { // 참가신청 정보 관리
        retrieveEntry();
    } else if(tabIndex.value === 2) { // 이력서 관리 및 입사지원 현황
        retrieveOjfResumeListAdminPaging();
    } else if(tabIndex.value === 3) { // 관심 기업
        retrieveInterestHallEntryListAdminPaging();
    } else if(tabIndex.value === 4) { // 관심 공고
        retrieveInterestJobNoticeListAdminPaging();
    } else if(tabIndex.value === 5) { // 받은 면접제안
        retrieveInterviewProposalEntryListAdminPaging();
    }
    viewMode.value = BASIC;
}

// 행사 상세로 이동
const goOjfDetail = () => {
    router.push({ name: 'OjfDetail', params:{id: ojfId.value} })
}

// 행사 상세 새 창으로 열기
const openOjfDetailInNewWindow = () => {
    const url = router.resolve({
        name: 'OjfDetail',
        params: { id: ojfId.value },
    }).href;

    const windowFeatures = 'width=1000,height=800,top=100,left=100,resizable=yes,scrollbars=yes';
    window.open(url, '_blank', windowFeatures);
}

// 면접 가능일 전체인지 확인 후 문구 표시
// 참가신청 정보 관리
const allDays1 = computed(() => entryDetail.value.intvAbleDay.split(','))
const isAllSelected1 = computed(() => (intvDays.value || []).length === allDays1.value.length)
// 이력서 관리 및 입사지원 현황 - 입사지원
const allDays2 = computed(() => applicantList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected2 = computed(() => (intvDays.value || []).length === allDays2.value.length)
// 관심 기업 - 채용공고
const allDays3 = computed(() => jobNoticeList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected3 = computed(() => (intvDays.value || []).length === allDays3.value.length)
// 관심 공고
const allDays4 = computed(() => interestJobNoticeList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected4 = computed(() => (intvDays.value || []).length === allDays4.value.length)
// 받은 면접제안
const allDays5 = computed(() => interviewProposalEntryList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected5 = computed(() => (intvDays.value || []).length === allDays5.value.length)

// 뒤로
const goBack = () => {
    router.go(-1);
}
</script>

<template>
    <div class="container">
        <div class="flex-wrap admin">
            <SNBAdmin class="snb" />
            <div class="content">
                <div class="sub-title">
                    <h3>{{ ojfDetail.ojfName }}</h3>
                </div>
                <div class="list-top space-between">
                    <KSASecondaryButton class="gray_button" text="목록" @click="goBack" />
                    <div>
                        <KSASecondaryButton class="gray_button ml-xs" text="행사 상세 새 창 보기" @click="openOjfDetailInNewWindow" />
                    </div>
                </div>
                <KSATab style="grid-template-columns: repeat(5, 1fr);" class="mb-sm"
                    :options="tabOptions"
                    @change="onChangeTab"
                />

                <!-- s: tabIndex 1 : 참가신청 정보 관리 ------------------------------------------------------------->
                <div class="table-form" v-if="loaded && tabIndex === 1">
                  <div class="state-box">
                    ● 현재 참가 신청 상태 : <span>{{ $gbNameKR('USER_JOIN_STATE_GB', entryDetail.joinStateGb) }}</span>
                  </div>
                  <!-- s: tabIndex 1 : 참가신청 정보 관리 : 보기 모드------------------------------------------------->
                  <div v-if="viewMode === BASIC">
                    <table class="vertical align-left">
                      <colgroup>
                        <col width="20%" />
                        <col />
                      </colgroup>
                      <tr>
                        <th colspan="2">● 참가신청 정보</th>
                      </tr>
                      <!-- ella : 참가 목적 숨김 요청 (20250904) -->
<!--                      <tr>-->
<!--                        <th>참가 목적</th>-->
<!--                        <td>{{ entryDetail.joinPurpose }}</td>-->
<!--                      </tr>-->
                      <tr>
                        <th>면접 가능일</th>
                        <td>
                          <p v-if="entryDetail.intvInYn === 'Y' && isAllSelected1">
                            전체 일정 가능
                            [{{ entryDetail.intvAbleDay }}]
                          </p>
                          <p v-else-if="entryDetail.intvInYn === 'Y'">{{ entryDetail.intvAbleDay }}</p>
                          <p v-else>면접 일정 조율</p>
                        </td>
                      </tr>
                    </table>
                    <div v-if="entryDetail.joinStateGb === '01' || entryDetail.joinStateGb === '02'" class="btn-wrap space-between mb-xs">
                        <KSASecondaryButton class="red_button" text="신청 취소" @click="cancelEntry('04')" />
                        <KSAPrimaryButton class="gray_button" text="수정" @click="setViewMode(ENTRY_UPDATE)" />
                    </div>
                  </div>
                  <!-- e: tabIndex 1 : 참가신청 정보 관리 : 보기 모드------------------------------------------------->
                  <!-- s: tabIndex 1 : 참가신청 정보 관리 : 수정 모드------------------------------------------------->
                  <div v-else-if="viewMode === ENTRY_UPDATE">
                    <table class="vertical align-left">
                      <colgroup>
                        <col width="20%" />
                        <col />
                      </colgroup>
                      <tr>
                        <th colspan="2">참가 신청 정보</th>
                      </tr>
                      <!-- ella : 참가 목적 숨김 요청 (20250904) -->
<!--                      <tr>-->
<!--                        <th class="mark">참가 목적</th>-->
<!--                        <td>-->
<!--                          <KSAInput v-model="entryDetail.joinPurpose" placeholder="ex) 취업 기회 탐색, 채용 정보 획득, 기업의 인사 담당자 또는 채용 관계자와의 네트워킹 등" />-->
<!--                          <p>-->
<!--                            <small style="color:#E71414;">{{ entryInputError.joinPurpose }}</small>-->
<!--                          </p>-->
<!--                        </td>-->
<!--                      </tr>-->
                      <tr>
                        <th rowspan="2">
                          <span class="mark">면접 가능일</span>
                        </th>
                        <td>
                          <ul class="grid category-wrap">
                            <li :class="{'active': isAllActive}" @click="onClickAll(false)">전체 일정 가능</li>
                            <li :class="{'active': day.on, 'disabled': isAllActive}" v-for="day in intvDays" @click="onClickIntvDay(day)">
                              {{ day.label }}
                            </li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <ul class="grid category-wrap">
                            <li :class="{'active': isEtcActive}" @click="onClickEtc(false)">면접 일정 조율</li>
                          </ul>
                          <p>
                            <small style="color:#E71414;">{{ entryInputError.intvAbleDay }}</small>
                          </p>
                        </td>
                      </tr>
                    </table>
                    <div class="btn-wrap space-between">
                      <KSASecondaryButton class="gray_button" text="취소" @click="cancelUpdateEntry" />
                      <KSASecondaryButton text="수정 완료" @click="ojfUpdateEntry" />
                    </div>
                  </div>
                  <!-- e: tabIndex 1 : 참가신청 정보 관리 : 수정 모드------------------------------------------------->
                </div>
                <!-- e: tabIndex 1 : 참가신청 정보 관리 ------------------------------------------------------------->

                <!-- s: tabIndex 2 : 이력서 관리 및 입사지원 현황 ----------------------------------------------------->
                <div v-else-if="tabIndex === 2">
                    <!-- s: tabIndex 2 : 이력서 관리 및 입사지원 현황 - 이력서 리스트 ----------------------------------->
                    <div v-if="viewMode === BASIC">
                        <!-- s: 버튼영역 -->
                        <div class="list-top">
                            <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                            <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                        </div>
                        <!-- e: 버튼영역 -->
                        <div class="table-form">
                            <table class="horizontal" v-if="resumeList !== null">
                                <tr>
                                    <th>NO</th>
                                    <th>내 이력서 제목</th>
                                    <th>입사지원</th>
                                    <th>최근 수정일</th>
                                    <th>등록일</th>
                                    <th>인재정보 공개</th>
                                </tr>
                                <tr v-for="ojf in resumeList">
                                    <td>{{ ojf.boardNo }}</td>
                                    <td class="text-overflow long-overflow">
                                        <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                                            {{ resumeAttaches.fileName }}
                                        </span>
                                        <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                                            {{ ojf.title }}
                                        </span>
                                    </td>
                                  <td class="clickable blue" @click="setViewMode(RESUME_APPLICANT, ojf.resumeId, ojf.fileYn)">{{ ojf.applicantCnt }}</td>
                                    <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                                    <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                                    <td>
                                        <span v-if="ojf.resOpenYn === 'Y'">
                                            <img src="../../../../assets/images/toggle_on.png" @click="onClickChangeResOpenYn(ojf.userId, ojf.resumeId, 'N')" style="cursor:pointer;" />
                                        </span>
                                        <span v-else>
                                            <span v-if="ojf.fileYn === 'Y'">
                                                -
                                            </span>
                                            <span v-else>
                                                <img src="../../../../assets/images/toggle_off.png" @click="onClickChangeResOpenYn(ojf.userId, ojf.resumeId, 'Y')" style="cursor:pointer;" />
                                            </span>
                                        </span>
                                    </td>
                                </tr>
                            </table>
                            <div class="result-none" v-if="resumeList.length === 0">
                                등록된 이력서가 없습니다.
                            </div>
                        </div>
                        <Paginate
                            v-if="resumeList.length > 0"
                            v-model="currentPage"
                            :page-count="totalPages"
                            :click-handler="onSelectPage"
                        />
                    </div>
                    <!-- e: tabIndex 2 : 이력서 관리 및 입사지원 현황 - 이력서 리스트 ----------------------------------->
                    <!-- s: tabIndex 2 : 이력서 관리 및 입사지원 현황 - 입사지원 리스트 --------------------------------->
                    <div v-else-if="viewMode === RESUME_APPLICANT">
                      <KSASecondaryButton text="이전" @click="setViewMode(BASIC)" />
                      <div class="list-top">
                        <p>총<span>{{ $number(totalCount)}}</span>명</p>
                        <div v-if="detailCommonData === 'N'">
                          <KSAPrimaryButton text="이력서 보기" @click="onClickMyResume(detailCommonId)" />
                        </div>
                      </div>
                      <div class="table-form">
                        <table class="horizontal" v-if="applicantList !== null">
                          <tr>
                            <th>NO</th>
                            <th>기업명</th>
                            <th>마스터</th>
                            <th>채용공고 제목</th>
                            <th>관심 카테고리</th>
                            <th>면접 가능일</th>
                            <th>면접 방식</th>
                            <th>입사 지원일</th>
                            <th>상태</th>
                            <th>상태변경</th>
                          </tr>
                          <tr v-for="ojf in applicantList">
                            <td>{{ ojf.boardNo }}</td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                            </td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                            </td>
                            <td class="clickable blue" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                            <td>{{ ojf.interests }}</td>
                            <td class="word-break-all">
                              <span v-if="ojf.intvInYn === 'Y' && isAllSelected2">
                                전체 일정 가능
                                [{{ ojf.intvAbleDay }}]
                              </span>
                              <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                              <span v-else>면접 일정 조율</span>
                            </td>
                            <td>{{ $gbNameKR('INTV_GB', ojf.intvGb) }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                            <td>
                              <span v-if="ojf.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                              <span v-else-if="ojf.applyStateGb === '03'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                              <span v-else-if="ojf.applyStateGb === '04'" class="red">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                              <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                            </td>
                            <td>
                              <div v-if="ojf.applyStateGb === '01'">
                                <KSATextButton class="clickable red_button" text="지원취소" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '02')"/>
                              </div>
                              <div v-else>
                                -
                              </div>
                            </td>
                          </tr>
                        </table>
                        <div class="result-none" v-if="applicantList.length === 0">
                          입사지원 내역이 없습니다.
                        </div>
                      </div>
                      <Paginate
                          v-if="applicantList.length > 0"
                          v-model="currentPage"
                          :page-count="totalPages"
                          :click-handler="onSelectPage"
                      />
                    </div>
                    <!-- e: tabIndex 2 : 이력서 관리 및 입사지원 현황 - 입사지원 리스트 --------------------------------->
                </div>
                <!-- e: tabIndex 2 : 이력서 관리 및 입사지원 현황 ----------------------------------------------------->

                <!-- s: tabIndex 3 : 관심 기업 --------------------------------------------------------------------->
                <div v-else-if="tabIndex === 3">
                    <!-- s: tabIndex 3 : 관심 기업 - 기업 리스트 ---------------------------------------------------->
                    <div v-if="viewMode === BASIC">
                        <!-- s: 버튼영역 -->
                        <div class="list-top">
                            <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                            <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                        </div>
                        <!-- e: 버튼영역 -->
                        <div class="table-form">
                            <table class="horizontal" v-if="interestHallList !== null">
                                <tr>
                                    <th>NO</th>
                                    <th>기업명</th>
                                    <th>마스터</th>
                                    <th>기업형태</th>
                                    <th>산업군</th>
                                    <th>업종</th>
                                    <th>채용공고</th>
                                    <th>관심 등록일</th>
                                </tr>
                                <tr v-for="ojf in interestHallList">
                                    <td>{{ ojf.boardNo }}</td>
                                    <td class="clickable blue">
                                        <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                                    </td>
                                    <td class="clickable blue">
                                        <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                                    </td>
                                    <td>{{ $gbNameKR('CORP_GB', ojf.corpGb)}}</td>
                                    <td>{{ $gbNameKR('INDUSTRY_GB', ojf.industryGb) }}</td>
                                    <td>{{ ojf.bizType }}</td>
                                    <td class="clickable blue" @click="setViewMode(CORPORATION_JOBNOTICE, ojf.corpId)">{{ ojf.jobNoticeCnt }}</td>
                                    <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                                </tr>
                            </table>
                            <div class="result-none" v-if="interestHallList.length === 0">
                                등록된 관심 기업이 없습니다.
                            </div>
                        </div>
                        <Paginate
                            v-if="interestHallList.length > 0"
                            v-model="currentPage"
                            :page-count="totalPages"
                            :click-handler="onSelectPage"
                        />
                    </div>
                    <!-- e: tabIndex 3 : 관심 기업 - 기업 리스트 ---------------------------------------------------->
                    <!-- s: tabIndex 3 : 관심 기업 - 채용공고 리스트 ------------------------------------------------->
                    <div v-else-if="viewMode === CORPORATION_JOBNOTICE">
                        <!-- s: 버튼영역 -->
                        <KSASecondaryButton text="이전" @click="setViewMode(BASIC)" />
                        <div class="list-top">
                            <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                            <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                        </div>
                        <!-- e: 버튼영역 -->
                        <div class="table-form">
                          <table class="horizontal" v-if="jobNoticeList !== null">
                            <tr>
                              <th>NO</th>
                              <th>채용공고 제목</th>
                              <th>등록 마스터</th>
                              <th>관심 카테고리</th>
                              <th>면접 가능일</th>
                              <th>면접 방식</th>
                              <th>채용공고 등록일</th>
                              <th>입사 지원 상태</th>
                            </tr>
                            <tr v-for="ojf in jobNoticeList">
                              <td>{{ ojf.boardNo }}</td>
                              <td class="clickable blue" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                              <td class="clickable blue">
                                <RouterLink :to="{name:'MemberDetail', params:{id: ojf.createId}}">{{ ojf.userName }}</RouterLink>
                              </td>
                              <td>{{ ojf.interests }}</td>
                              <td class="word-break-all">
                                <span v-if="ojf.intvInYn === 'Y' && isAllSelected3">
                                  전체 일정 가능
                                  [{{ ojf.intvAbleDay }}]
                                </span>
                                <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                                <span v-else>면접 일정 조율</span>
                              </td>
                              <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                              <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                              <td>
                                <span v-if="ojf.applyStateGb" class="gray">지원완료</span>
                                <span v-else>-</span>
                              </td>
                            </tr>
                          </table>
                          <div class="result-none" v-if="jobNoticeList.length === 0">
                            등록된 채용공고가 없습니다.
                          </div>
                        </div>
                        <Paginate
                            v-if="jobNoticeList.length > 0"
                            v-model="currentPage"
                            :page-count="totalPages"
                            :click-handler="onSelectPage"
                        />

                    </div>
                    <!-- e: tabIndex 3 : 관심 기업 - 채용공고 리스트 ------------------------------------------------->
                </div>
                <!-- e: tabIndex 3 : 관심 기업 -------------------------------------------------------------------->

                <!-- s: tabIndex 4 : 관심 공고 -------------------------------------------------------------------->
                <div v-else-if="tabIndex === 4">
                    <!-- s: 버튼영역 -->
                    <div class="list-top">
                        <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                    </div>
                    <!-- e: 버튼영역 -->
                    <div class="table-form">
                        <table class="horizontal" v-if="interestJobNoticeList !== null">
                            <tr>
                                <th>NO</th>
                                <th>기업명</th>
                                <th>마스터</th>
                                <th>채용공고 제목</th>
                                <th>관심 카테고리</th>
                                <th>면접 가능일</th>
                                <th>면접 방식</th>
                                <th>관심 등록일</th>
                                <th>입사지원 상태</th>
                            </tr>
                            <tr v-for="ojf in interestJobNoticeList">
                                <td>{{ ojf.boardNo }}</td>
                                <td class="clickable blue">
                                    <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                                </td>
                                <td class="clickable blue">
                                    <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                                </td>
                                <td class="clickable blue" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                                <td>{{ ojf.interests }}</td>
                                <td class="word-break-all">
                                    <span v-if="ojf.intvInYn === 'Y' && isAllSelected4">
                                      전체 일정 가능
                                      [{{ ojf.intvAbleDay }}]
                                    </span>
                                    <span v-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                                    <span v-else>면접 일정 조율</span>
                                </td>
                                <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                                <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                                <td>
                                    <span v-if="ojf.applyStateGb === '01' || ojf.applyStateGb === '02' || ojf.applyStateGb === '03' || ojf.applyStateGb === '04'" class="gray">지원완료</span>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                        </table>
                        <div class="result-none" v-if="interestJobNoticeList.length === 0">
                            등록된 관심 공고가 없습니다.
                        </div>
                    </div>
                    <Paginate
                        v-if="interestJobNoticeList.length > 0"
                        v-model="currentPage"
                        :page-count="totalPages"
                        :click-handler="onSelectPage"
                    />
                </div>
                <!-- e: tabIndex 4 : 관심 공고 -------------------------------------------------------------------->

                <!-- s: tabIndex 5 : 받은 면접제안 ----------------------------------------------------------------->
                <div v-else-if="tabIndex === 5">
                  <!-- s: 버튼영역 -->
                  <div class="list-top">
                    <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                    <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                  </div>
                  <!-- e: 버튼영역 -->
                  <div class="table-form">
                    <table class="horizontal" v-if="interviewProposalEntryList !== null">
                      <tr>
                        <th>NO</th>
                        <th>기업명</th>
                        <th>마스터</th>
                        <th>채용공고 제목</th>
                        <th>관심 카테고리</th>
                        <th>면접 가능일</th>
                        <th>면접 방식</th>
                        <th>내 이력서 제목</th>
                        <th>제안 받은일</th>
                        <th>상태</th>
                        <th>상태변경</th>
                      </tr>
                      <tr v-for="ojf in interviewProposalEntryList">
                        <td>{{ ojf.boardNo }}</td>
                        <td class="clickable blue">
                          <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                        </td>
                        <td class="clickable blue">
                          <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                        </td>
                        <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                        <td>{{ ojf.interests }}</td>
                        <td class="word-break-all">
                          <span v-if="ojf.intvInYn === 'Y' && isAllSelected5">
                            전체 일정 가능
                            {{ ojf.intvAbleDay }}
                          </span>
                          <span v-else-if="ojf.intvInYn === 'Y'">{{ ojf.intvAbleDay }}</span>
                          <span v-else>면접 일정 조율</span>
                        </td>
                        <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                        <td class="clickable blue text-overflow long-overflow" @click="onClickMyResume(ojf.resumeId)">{{ ojf.title }}</td>
                        <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                        <td :class="ojf.intvPropStateGb === '02' ? 'blue' : ojf.intvPropStateGb === '03' ? 'red' : ojf.intvPropStateGb === '04' ? 'gray' : ''">
                          {{ $gbNameKR("USER_INTV_PROP_STATE_GB", ojf.intvPropStateGb) }}
                        </td>
                        <td>
                          <div v-if="ojf.intvPropStateGb === '01'">
                            <KSATextButton text="제안수락" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '02')" class="clickable"></KSATextButton>
                            ,
                            <KSATextButton text="제안거절" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '03')" class="clickable red_button"></KSATextButton>
                          </div>
                          <div v-else>-</div>
                        </td>
                      </tr>
                    </table>
                    <div class="result-none" v-if="interviewProposalEntryList.length === 0">
                      받은 면접제안이 없습니다.
                    </div>
                  </div>
                  <Paginate
                      v-if="interviewProposalEntryList.length > 0"
                      v-model="currentPage"
                      :page-count="totalPages"
                      :click-handler="onSelectPage"
                  />
                </div>
                <!-- e: tabIndex 5 : 받은 면접제안 ----------------------------------------------------------------->

            </div>
        </div>
    </div>
    <AlertModal ref="modal" :content="modalContent" />
    <ConfirmModal ref="confirmModal" :content="modalContent" :okButtonText="okButtonText" cancelButtonText="취소" />
    <JobFairResumeModal ref="jobFairResumeModal" /> <!-- 특별채용관 이력서 상세 -->
    <JobFairJobNoticeModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
    <JobFairResumeOpenModal ref="jobFairResumeOpenModal" :showButtons="false"/> <!-- 텍스트 색상을 위한 디자인 팝업 -->
</template>

<style lang="scss" scoped>
@import "../../../../assets/scss/theme";

.textarea-box {
    height: 100px;
}
.blue {
    color: $blue_color;
}
.red {
    color: $red_color;
}
.state-box {
  border: 2px solid $black_color;
  padding: 10px 20px;
  span {
    color: $blue_color;
  }
}
.file {
  color: $blue_color;
  cursor: pointer;
}
.table-form {
    table {
        &.vertical {
            &.align-left {
                th {
                    text-align: left;
                    span {
                        display: block;
                        font-size: $font-size_xs;
                        color: $gray_color;
                        font-weight: normal;
                    }
                }
            }
        }
    }
    .clickable {
        text-decoration: underline;
        cursor: pointer;
    }
    .disabled {
        cursor: default;
        background: $gray-regular_color;
        border-color: $gray-regular_color;
        color: #fff;
    }
}
</style>